import { render, staticRenderFns } from "./PrkBeamSyllabusesStudent.vue?vue&type=template&id=50c1d35c&"
import script from "./PrkBeamSyllabusesStudent.vue?vue&type=script&lang=js&"
export * from "./PrkBeamSyllabusesStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports